import React from 'react';
import { useInView } from 'react-intersection-observer';
import './FutureSection.css';

// Each "star" has vertical and horizontal lines
function StarSVG({ size = 18, x = 0, y = 0, color = "#fff", opacity = 0.28 }) {
  return (
    <svg
      className="future-star-svg"
      width={size}
      height={size}
      style={{
        left: `${x}%`,
        top: `${y}%`,
        position: 'absolute',
        opacity
      }}
      viewBox="0 0 18 18"
      fill="none"
    >
      <circle cx="9" cy="9" r={1.3} fill={color} />
      <rect x="8.4" y="2.2" width="1.2" height="13.6" rx="0.57" fill={color} />
      <rect x="2.2" y="8.4" width="13.6" height="1.2" rx="0.57" fill={color} />
    </svg>
  );
}

const lines = [
  <>The Future is Human <span className="special-plusai">plus</span> AI.</>,
  <>We’ve entered a new era of software development where human and AI build together. This changes the skills you need as a developer, and the way companies engage, hire, and upskill technical talent. In short, this changes everything.</>,
  <>We’re embracing these changes with you, and we’ve reinvented our products to meet the moment.</>
];

export default function FutureSection({ theme = 'dark' }) {
  return (
    <section className={`future-space-section theme-${theme}`}>
      <link href="https://fonts.googleapis.com/css2?family=Pixelify+Sans:wght@700&display=swap" rel="stylesheet" />

      {/* Stars with cross lines */}
      <div className="future-stars">
        {Array.from({ length: 55 }).map((_, i) => (
          <StarSVG
            key={i}
            size={Math.random() < 0.32 ? 18 : 10}
            x={Math.random() * 100}
            y={Math.random() * 100}
            color="var(--future-star)"
            opacity={0.18 + Math.random() * 0.33}
          />
        ))}
      </div>

      <div className="future-space-content">
        {lines.map((line, i) => (
          <LineReveal key={i} index={i} isGreenFirst={i === 0}>
            {line}
          </LineReveal>
        ))}
      </div>
    </section>
  );
}

function LineReveal({ children, index, isGreenFirst }) {
  const { ref, inView } = useInView({ threshold: 0.73, triggerOnce: false });
  return (
    <div
      ref={ref}
      className={`future-space-line${inView ? ' line-in-view' : ''}${isGreenFirst ? ' green-headline' : ''}`}
      style={{
        transitionDelay: `${index * 0.08 + (isGreenFirst ? 0.08 : 0)}s`
      }}
    >
      {children}
    </div>
  );
}
